/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PromisableAction } from "models/promisable-action";

export interface LinkerRoleRequest extends PromisableAction {
  idUsuario: string;
  role: string;  
}

interface State {
  isRequesting: boolean;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  errors: [],
};

const linkerRoleSlice = createSlice({
  name: "users@linkerRole",
  initialState,
  reducers: {
    linkerRole: (state, action: PayloadAction<LinkerRoleRequest>): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    linkerRoleSuccess: (state): void => {
      state.isRequesting = false;
    },
    linkerRoleFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    },
  },
});

export const { linkerRole, linkerRoleSuccess, linkerRoleFailed } =
  linkerRoleSlice.actions;

export default linkerRoleSlice.reducer;
